import { useGetMany, useGetOne, useTranslate, type Identifier } from "ra-core";
import { useWatch } from "react-hook-form";
import { Badge } from "@/components/ui/badge";

import type { Deal, Partner } from "../types";

/** Read-only staff of the opportunity chosen on the event form. */
export const EventDealStaff = () => {
  const translate = useTranslate();
  const dealId = useWatch<{ deal_id?: Identifier | null }>({ name: "deal_id" });
  const { data: deal } = useGetOne<Deal>(
    "deals",
    { id: dealId ?? "" },
    { enabled: dealId != null && dealId !== "" },
  );
  const partnerIds = deal?.partner_ids ?? [];
  const { data: partners = [] } = useGetMany<Partner>(
    "partners",
    { ids: partnerIds },
    { enabled: partnerIds.length > 0 },
  );
  if (!deal) return null;

  return (
    <div className="flex flex-col gap-1 text-sm">
      <span className="text-muted-foreground">
        {translate("resources.events.deal_staff")}
      </span>
      {partners.length ? (
        <div className="flex flex-wrap gap-1">
          {partners.map((partner) => (
            <Badge key={partner.id} variant="secondary" className="font-normal">
              {partner.name}
            </Badge>
          ))}
        </div>
      ) : (
        <span className="italic text-muted-foreground">
          {translate("resources.deals.staff.empty")}
        </span>
      )}
    </div>
  );
};
